/*
 * @Author: wangshengqiang
 * @Date: 2021-05-19 10:48:45
 * @LastEditTime: 2021-12-26 15:05:24
 * @LastEditors: wangshengqiang
 * @Description: 利益演示工具栏
 */
import React, { useState, useEffect, useMemo, useContext } from 'react';
import styled from 'styled-components';
import { Popper, Modal } from 'zarm';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { dispatch as dvaDispatch } from '@/store';
import { ModuleContext } from '../BaseModule';
import './index.less';

const BenefitDemonstrationBar = props => {
  const {
    attrs
  } = props;
  const {
    benefitTable
  } = useContext(ModuleContext);
  const {
    insured,
    isShow,
    productBenefit
  } = attrs;
  const {
    datas,
    titles,
    comparisonChartAttr = [],
    benefitFactors
  } = benefitTable || {}; // if ( !benefitTable) return null;

  const formatBenefitTable = useMemo(() => {
    const result = {};
    comparisonChartAttr === null || comparisonChartAttr === void 0 ? void 0 : comparisonChartAttr.forEach(({
      itemCode,
      detailDesc,
      displayName,
      value
    }) => {
      result[itemCode] = {
        detailDesc,
        displayName,
        value
      };
    });
    return result;
  }, [benefitTable]);
  useEffect(() => {
    // 第一次进来把选中的利益演示表存入store
    dvaDispatch({
      productBenefit: productBenefit || {}
    }); // 这样存会和利益演示滑动图模块产生覆盖
  }, []);
  if (!isShow || !benefitTable) return null;
  const TOTAL_BENEFIT_D_PREMIUM = formatBenefitTable.TOTAL_BENEFIT_D_PREMIUM || {};
  const TOTAL_PREMIUM = formatBenefitTable.TOTAL_PREMIUM || {};
  const TOTAL_BENEFIT = formatBenefitTable.TOTAL_BENEFIT || {};
  const ratioValue = Number(TOTAL_BENEFIT_D_PREMIUM.value);
  const ratio = Number.isFinite(1 / ratioValue) ? 0 : (1 / ratioValue).toFixed(2);

  const showDetailDesc = desc => {
    const modal = Modal.alert({
      content: desc,
      cancelText: '知道了',
      onCancel: () => {
        modal.hide();
      }
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "benefit-bar-chart"
  }, /*#__PURE__*/React.createElement(StyledTitle, {
    className: "chart-title"
  }, TOTAL_BENEFIT_D_PREMIUM.displayName, "\u2248", /*#__PURE__*/React.createElement("span", null, TOTAL_BENEFIT_D_PREMIUM.value), "\u500D"), /*#__PURE__*/React.createElement("div", {
    className: "progress-container"
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
    style: {
      width: `${ratio}%`
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "label-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "chart-label"
  }, /*#__PURE__*/React.createElement("div", {
    className: "label-title"
  }, TOTAL_PREMIUM.displayName, /*#__PURE__*/React.createElement(QuestionCircleOutlined, {
    onClick: () => showDetailDesc(TOTAL_PREMIUM.detailDesc)
  })), /*#__PURE__*/React.createElement("div", {
    className: "label-content"
  }, TOTAL_PREMIUM.value, "\u5143")), /*#__PURE__*/React.createElement("div", {
    className: "chart-label sum"
  }, /*#__PURE__*/React.createElement("div", {
    className: "label-title"
  }, TOTAL_BENEFIT.displayName, /*#__PURE__*/React.createElement(QuestionCircleOutlined, {
    onClick: () => showDetailDesc(TOTAL_BENEFIT.detailDesc)
  })), /*#__PURE__*/React.createElement("div", {
    className: "label-content"
  }, TOTAL_BENEFIT.value, "\u5143"))));
};

export default BenefitDemonstrationBar;
const StyledTitle = styled.div`
  padding: 0 22px;
  text-align: center;
  font-size: 24px;
  & > span {
    color: blue;
  }
`;